import { NotesPanel } from "./NotesPanel";
import { monthBounds } from "../lib/notes";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { monthLabel, topUsersForMonth } from "../lib/csvAnalysis";
import { fmtNum, slug } from "../lib/format";

export const MonthSpotlight = ({ data, month, setMonth, onOpenUser }) => {
  const i = data.months.indexOf(month);
  const pt = data.overall[i];
  const top = topUsersForMonth(data.users, month);
  const max = top[0]?.visits || 1;
  const step = (d) => setMonth(data.months[Math.min(data.months.length - 1, Math.max(0, i + d))]);
  return (
    <div className="panel p-5 sm:p-6 h-full" data-testid="month-spotlight">
      <div className="flex items-center justify-between">
        <p className="label-mono">Month spotlight</p>
        <div className="flex gap-1">
          <button data-testid="spotlight-prev" onClick={() => step(-1)} className="p-1 rounded hover:bg-slate-800 text-slate-400"><ChevronLeft className="h-4 w-4" /></button>
          <button data-testid="spotlight-next" onClick={() => step(1)} className="p-1 rounded hover:bg-slate-800 text-slate-400"><ChevronRight className="h-4 w-4" /></button>
        </div>
      </div>
      <p className="font-display text-2xl font-bold text-slate-100 mt-2" data-testid="spotlight-month">{monthLabel(month)}</p>
      <div className="grid grid-cols-2 gap-3 mt-4">
        <div className="rounded-lg bg-[#0B0F19] border border-slate-800 p-3"><p className="text-[10px] label-mono">Visits</p><p className="font-mono text-lg text-ep-soft" data-testid="spotlight-visits">{fmtNum(pt?.visits)}</p></div>
        <div className="rounded-lg bg-[#0B0F19] border border-slate-800 p-3"><p className="text-[10px] label-mono">Qty</p><p className="font-mono text-lg text-emerald-400">{data.hasQty ? fmtNum(pt?.qty) : "—"}</p></div>
        {data.hasHop && <div className="col-span-2 rounded-lg bg-[#0B0F19] border border-slate-800 p-3"><p className="text-[10px] label-mono">Picks / hour</p><p className="font-mono text-lg text-cyan-400" data-testid="spotlight-pph">{fmtNum(pt?.pph)}</p></div>}
      </div>
      <p className="label-mono mt-6 mb-3">Top users this month</p>
      <div className="space-y-1">
        {top.length === 0 && <p className="text-xs text-slate-500">No activity.</p>}
        {top.map((u) => (
          <button key={u.id} data-testid={`spotlight-user-${slug(u.id)}`} onClick={() => onOpenUser(u.id)} className="w-full text-left group rounded-md px-2 py-1.5 hover:bg-slate-800/60 transition-colors">
            <div className="flex justify-between text-xs"><span className="text-slate-300 truncate group-hover:text-white">{u.id}</span><span className="font-mono text-slate-400">{fmtNum(u.visits)}</span></div>
            <div className="h-1 mt-1 rounded bg-slate-800"><div className="h-1 rounded bg-ep" style={{ width: `${(u.visits / max) * 100}%` }} /></div>
          </button>
        ))}
      </div>
      <div className="mt-6 pt-5 border-t border-slate-800">
        <NotesPanel title="Notes this month" start={monthBounds(month).start} end={monthBounds(month).end} defaults={{ period: "month", value: month }} pickers={data.users.map((u) => u.id)} testId="spotlight-notes" limit={3} />
      </div>
    </div>
  );
};
